const fixPhpJSONConvertedObject = (structure: any) => {
  const jsonString = JSON.stringify(structure);
  if (!jsonString) {
    return structure;
  }
  return JSON.parse(jsonString.replace(/"extra":\[\]/g, '"extra":{}'));
};

export default fixPhpJSONConvertedObject;
